import { RootState } from 'store'

export const all = (state: RootState) => state.property
